<template>
  <div class="redact_container">
    <el-button class="top_btn" @click="addClick">新增</el-button>
    <el-table
      ref="multipleTable"
      :data="tableData"
      tooltip-effect="dark"
      style="width: 100%"
      highlight-current-row
      @selection-change="handleSelectionChange"
      stripe
      border
      v-loading="tableLoading"
    >
      <el-table-column type="selection" width="55" align="center">
      </el-table-column>
      <el-table-column property="number" label="序号" width="55" align="center">
      </el-table-column>
      <el-table-column property="accidentSn" label="事故编号"> </el-table-column>
      <el-table-column property="accidentTime" label="事故时间"> </el-table-column>
      <el-table-column property="accidentAddress" label="事故地点"> </el-table-column>
      <el-table-column property="accidentTypeStr" label="事故性质"> </el-table-column>
      <el-table-column property="accidentDutyStr" label="事故责任"> </el-table-column>
      <el-table-column property="carSituation" label="车辆损坏情况">
      </el-table-column>
      <el-table-column property="createUserName" label="登记人员"> </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="text" @click="goRedact(scope.row)">编辑</el-button>
          <el-button type="text" @click="goDetele(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="paging_box">
      <!--  :current-page="currentPage4" -->
      <el-pagination
        @size-change="handleSizeChange"
        background
        @current-change="handleCurrentChange"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="tableParams.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>

    <v-addCarAccident
      :dialogShow.sync="addCarAccidentShow"
      :carId="netId"
    ></v-addCarAccident>
    <v-reactCarAccident :dialogShow.sync="reactCarAccidentShow"
      :dialogData="reactCarAccidentData" :carId="netId"></v-reactCarAccident>
  </div>
</template>

<script>
import addCarAccident from "./tabDialog/addCarAccident.vue";
import reactCarAccident from './tabDialog/reactCarAccident.vue';
export default {
  name: "",
  data() {
    return {
      tableData: [],
      total: 0,
      tableLoading: false,
      addCarAccidentShow: false,
      reactCarAccidentShow:false,
      reactCarAccidentData:{},
      multipleSelection: [],
      tableParams: {
        id: 0,
        page: 1,
        limit: 10,
      },
    };
  },
  components: {
    "v-addCarAccident": addCarAccident,
    "v-reactCarAccident":reactCarAccident
  },
  props: {
    netId: Number,
  },
  created() {},
  methods: {
    getList() {
      this.tableLoading = true;
      this.tableParams.id = this.netId
      this.$http.getAccidentList(this.tableParams).then((res) => {
        this.tableLoading = false;
        if (res.code === 0) {
          this.tableData = res.data;
          this.total = res.count;
        } else {
          this.tableData = [];
          this.total = 0;
          this.$message.info(res.msg);
        }
      });
    },
    addClick() {
      this.addCarAccidentShow = true;
    },
    handleSelectionChange(e) {
      this.multipleSelection = val;
    },
    goRedact(row) {
      this.reactCarAccidentShow = true;
      this.reactCarAccidentData = row
    },
    goDetele(row) {},
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
    },
  },
};
</script>

<style lang="less" scoped>
@import "./redact.less";
</style>



// WEBPACK FOOTER //
// src/views/carAdmin/carTechnology_component/redact_carAccident.vue